import React from 'react';
import project from '../pages/ProjectsData'

function Project() {
  return (
      <div className="portfolio">
        <h1 className="portfolio-header">
          My Project Portfolio <br />
          <span className="portfolio-arrows">↓ ↓ ↓ ↓ ↓</span>
        </h1>
        {project.map((project, index) => (
          <div key={index} className={`portfolio-item ${index % 2 === 0 ? 'left' : 'right'}`}>
            
            <div className="portfolio-image">
              <img src={`./ProfileImage/${project.imageUrl}`} alt={project.title} />
            </div>

            <div className="portfolio-description">
              <h2>{project.title}</h2>
              <p>{project.description}</p>
              <a className="apple-link" href={project.link}>
                    <button className="learn-more-button" onClick={() => this.handleClick()}>
                        Learn More
                    </button>
                </a>
            </div>

          </div>
        ))}
      </div>
  );
}

export default Project;
